import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ExerciseChecklistEditComponent } from './exercise-checklist-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormElementsModule } from 'form-elements';
import { IonicModule } from '@ionic/angular';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormElementsModule,
    TranslateModule,
    IonicModule
  ],
  exports: [ExerciseChecklistEditComponent],
  declarations: [ExerciseChecklistEditComponent]
})
export class ExerciseChecklistEditComponentModule {}
